import React from 'react';

import AuthForm from './components/Auth/AuthForm';
import JobsList from './components/Dashboard/JobsList';
import Layout from './components/Layout/Layout';
import VideoUpload from './components/Upload/VideoUpload';
import { useAuth } from './hooks/useAuth';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <AuthForm />;
  }

  return (
    <Layout user={user}>
      <VideoUpload user={user} />
      <JobsList user={user} />
    </Layout>
  );
}

export default App;
